var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13824_45247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5785 21.9807L20.7517 24.0159C20.268 24.1417 19.7604 24.1442 19.2755 24.0233L11.0188 21.9644C9.70943 21.6379 8.79053 20.4618 8.79053 19.1122V10.0915C8.79045 4.51812 13.3086 0 18.8821 0H20.6867C26.2601 0 30.7782 4.51812 30.7782 10.0915V19.1359C30.7782 20.4744 29.8739 21.6439 28.5785 21.9807Z",
    fill: "#FD9727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6865 0H18.8819C18.4286 0 17.9824 0.0303906 17.5449 0.0882811C22.4863 0.74242 26.2996 4.9714 26.2996 10.0915V19.1359C26.2996 20.4744 25.3953 21.6439 24.0998 21.9808L17.7283 23.6375L19.2754 24.0233C19.7603 24.1443 20.2678 24.1417 20.7516 24.0159L28.5783 21.9807C29.8738 21.6439 30.7781 20.4744 30.7781 19.1358V10.0915C30.778 4.51812 26.2599 0 20.6865 0Z",
    fill: "#FF6D3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25779 16.3923H11.3992V11.1641H9.25779C8.62865 11.1641 8.11865 11.6741 8.11865 12.3032V15.253C8.11865 15.8823 8.62865 16.3923 9.25779 16.3923Z",
    fill: "#3D6687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.743 16.3923H28.6016V11.1641H30.743C31.3721 11.1641 31.8821 11.6741 31.8821 12.3032V15.253C31.8821 15.8823 31.3721 16.3923 30.743 16.3923Z",
    fill: "#3D6687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8352 25.5136C24.0863 25.363 23.5475 24.7051 23.5475 23.9412V20.3262H19.9999H16.4524V23.9412C16.4524 24.7051 15.9136 25.363 15.1647 25.5136L14.3003 25.6873V31.4927H19.9999H25.6996V25.6873L24.8352 25.5136Z",
    fill: "#FED9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2216 27.4634L25.1062 25.2448C24.8853 25.1759 24.6444 25.2318 24.4765 25.391L20.0002 29.6331L15.5238 25.3911C15.3559 25.2319 15.115 25.176 14.8942 25.2449L7.7787 27.4635C4.62402 28.3923 2.45801 31.2881 2.45801 34.5767V39.317C2.45801 39.6943 2.76394 40.0003 3.14129 40.0003H36.8591C37.2365 40.0003 37.5424 39.6943 37.5424 39.317V34.5767C37.5423 31.288 35.3763 28.3922 32.2216 27.4634Z",
    fill: "#FF4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.221 27.4634L25.1056 25.2448C24.8847 25.1759 24.6438 25.2318 24.4759 25.391L23.6392 26.184L27.7426 27.4634C30.8973 28.3922 33.0633 31.288 33.0633 34.5766V40.0002H36.8585C37.2359 40.0002 37.5418 39.6942 37.5418 39.3169V34.5766C37.5417 31.288 35.3757 28.3922 32.221 27.4634Z",
    fill: "#EF2929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 23.3326C15.1162 23.3326 11.1572 19.3736 11.1572 14.4899V12.0048C11.1572 7.12116 15.1163 3.16211 19.9999 3.16211C24.8836 3.16211 28.8427 7.12116 28.8427 12.0048V14.4899C28.8427 19.3736 24.8837 23.3326 19.9999 23.3326Z",
    fill: "#FED9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3638 4.3125V14.4896C24.3638 18.5996 21.5596 22.0544 17.7603 23.046C18.4755 23.2326 19.2258 23.3323 19.9995 23.3323C24.8832 23.3323 28.8422 19.3733 28.8422 14.4896V12.0045C28.8423 8.70804 27.0382 5.8332 24.3638 4.3125Z",
    fill: "#F4C892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5235 25.391L19.9998 29.633L17.2392 30.5735C16.5628 30.8039 15.8142 30.6036 15.3432 30.0661L11.9287 26.1693L14.8938 25.2448C15.1147 25.1759 15.3556 25.2318 15.5235 25.391Z",
    fill: "#D4145A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4763 25.391L20 29.633L22.502 30.4854C23.3349 30.7691 24.2567 30.5224 24.8366 29.8607L28.0711 26.1693L25.106 25.2448C24.8851 25.1759 24.6442 25.2318 24.4763 25.391Z",
    fill: "#D4145A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7175 36.4916H10.1661C9.91334 36.4916 9.7085 36.2868 9.7085 36.0341V34.0181C9.7085 33.7654 9.91334 33.5605 10.1661 33.5605H14.7175C14.9702 33.5605 15.175 33.7654 15.175 34.0181V36.0341C15.1751 36.2867 14.9702 36.4916 14.7175 36.4916Z",
    fill: "#EDA558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7783 11.9555C30.7783 11.9555 26.9631 11.6527 25.6577 8.14342C25.6577 8.14342 16.4351 15.5271 8.79053 11.9555V10.0915C8.79053 4.51812 13.3087 0 18.8821 0H20.6868C26.2602 0 30.7783 4.51812 30.7783 10.0915V11.9555Z",
    fill: "#FD9727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6865 0H18.8819C18.4286 0 17.9824 0.0303906 17.5449 0.0882811C22.2434 0.710233 25.9216 4.56437 26.2719 9.34334C27.8808 11.7251 30.778 11.9555 30.778 11.9555V10.0915C30.778 4.51812 26.2599 0 20.6865 0Z",
    fill: "#FF6D3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9914 33.2686C32.6578 33.2686 32.3872 33.539 32.3872 33.8728V40.0001H33.5956V33.8727C33.5956 33.539 33.3251 33.2686 32.9914 33.2686Z",
    fill: "#D4145A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.009 33.2686C6.67533 33.2686 6.40479 33.539 6.40479 33.8728V40.0001H7.61314V33.8727C7.61314 33.539 7.34267 33.2686 7.009 33.2686Z",
    fill: "#D4145A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0888 16.3916V17.4937C29.0888 18.4437 28.4092 19.2499 27.4728 19.4103L21.3929 20.453C21.0643 20.5093 20.8436 20.8214 20.8999 21.15C20.9503 21.444 21.2055 21.6517 21.4941 21.6517C21.528 21.6517 21.5623 21.6489 21.5968 21.6429L27.6768 20.6003C29.1944 20.34 30.296 19.0335 30.296 17.4937V16.3916H29.0888Z",
    fill: "#3D6687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5761 22.233C21.0177 22.233 20.5238 21.8312 20.4262 21.2622C20.3171 20.6264 20.7442 20.0225 21.38 19.9134L23.3497 19.5756C23.9856 19.4664 24.5894 19.8936 24.6984 20.5295C24.8075 21.1652 24.3804 21.7691 23.7446 21.8782L21.7749 22.216C21.7081 22.2274 21.6416 22.233 21.5761 22.233Z",
    fill: "#D4145A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13824_45247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.f2da02157fdc2f12ff9bcee9e659846a.svg";
export { ForwardRef as ReactComponent };